import { useMutation, useQueryClient } from '@tanstack/react-query';
import cashInstructionApi from '@/features/dashboard/paymentConfig/api/cashInstructionApi.ts';
import { cashInstructionApiQueryKeys } from '@/features/dashboard/paymentConfig/api/cashInstructionApi.queryKeys.ts';
import { CashInstructionDto } from '@/features/dashboard/paymentConfig/types/CashInstructionDto.ts';
import { toast } from 'sonner';

export default function useSetCashInstruction() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CashInstructionDto) => cashInstructionApi.set(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: cashInstructionApiQueryKeys.all(),
      });
      toast.success('Instrukcja płatności gotówką została zapisana');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message ||
          'Wystąpił błąd podczas zapisywania instrukcji płatności gotówką.',
      });
    },
  });
}
